import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { getNodeManager } from "@src/cloud-connect/dependency-injection-container/get-node-manager";
import store from "@src/reducers/store";
import { updateStructureWasSaved } from "@src/reducers/your-reducer";

export const dropInitialListInEmptyOurNodeMachineStructure = () => {
  const logger = getLogger();
  const t0 = performance.now();
  logger.debug("t0 - start of action", t0);

  const nodeManager = getNodeManager();
  const machineStructureNodeset = getMachineStructureNodeset();

  nodeManager
    .initialToMachineStructureFolderDragAndDropHandler()
    .initialToMachineStructureFolderDragAndDrop(
      machineStructureNodeset.rootNode,
    );

  store.dispatch(updateStructureWasSaved(false));

  const t1 = performance.now();
  logger.debug("t1 - end of action", t1);
  logger.debug(
    `Action to drop initial list in empty new machine structure took ${
      t1 - t0
    } milliseconds.`,
  );
};
